export default class LocalizacaoModel {
  public location: string = "";
  public city: string = "";
  public state: string = "";
  public latitude: number = 0;
  public longitude: number = 0;

  public static toModel(obj: any): LocalizacaoModel {
    return {
      location: obj.location,
      city: obj.city,
      state: obj.state,
      latitude: obj.lat,
      longitude: obj.long,
    } as LocalizacaoModel;
  }
}
